import React, { Component, useState, useEffect } from 'react';
import { Layout, Button, Row, Col, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import propTypes from 'prop-types';
import MenuItems from './MenuItems';
import { Div } from './style';
import AuthInfo from '../components/utilities/auth-info/info';
import { getItem, setItem } from '../utility/localStorageControl';
import { useAuth } from '../context/auth.context';
import CallOutcomePopup from '../components/call-outcome-popup';

const { Header, Footer, Sider, Content } = Layout;
// const { darkMode } = config;

const ThemeLayout = (WrappedComponent) => {
    const LayoutComponent = (props) => {
        const { currentUser } = useAuth();

        const [sidebarCollapsed, setSidebarCollapsed] = useState(
            getItem('sidebar_collapsed') === 'true' ? true : false,
        );
        useEffect(() => {
            window.addEventListener('resize', updateDimensions);
            return () => {
                window.removeEventListener('resize', updateDimensions);
            };
        }, []);

        const updateDimensions = () => {
            setSidebarCollapsed(window.innerWidth <= 1700);
        };
        const { ChangeLayoutMode, rtl, topMenu } = props;

        const left = !rtl ? 'left' : 'right';
        const darkMode = ChangeLayoutMode;

        const toggleCollapsed = () => {
            setItem('sidebar_collapsed', !sidebarCollapsed);
            setSidebarCollapsed(!sidebarCollapsed);
        };

        const SideBarStyle = {
            margin: '63px 0 0 0',
            padding: '15px 15px 55px 15px',
            overflowY: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            zIndex: 998,
        };

        const renderView = ({ style, ...props }) => {
            const customStyle = {
                marginRight: 'auto',
                [rtl ? 'marginLeft' : 'marginRight']: '-17px',
            };
            return <div {...props} style={{ ...style, ...customStyle }} />;
        };

        const renderThumbVertical = ({ style, ...props }) => {
            const { ChangeLayoutMode } = props;
            const thumbStyle = {
                borderRadius: 6,
                backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
                [left]: '2px',
            };
            return <div style={{ ...style, ...thumbStyle }} {...props} />;
        };

        const renderTrackVertical = () => {
            const thumbStyle = {
                position: 'absolute',
                width: '6px',
                transition: 'opacity 200ms ease 0s',
                opacity: 0,
                right: '2px',
                bottom: '2px',
                top: '2px',
                borderRadius: '3px',
            };
            return <div style={thumbStyle} />;
        };

        const renderThumbHorizontal = ({ style, ...props }) => {
            const { ChangeLayoutMode } = props;
            const thumbStyle = {
                borderRadius: 6,
                backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
            };
            return <div style={{ ...style, ...thumbStyle }} {...props} />;
        };

        return !currentUser ? (
            <div className="spin">
                <Spin />
            </div>
        ) : (
            <Div darkMode={darkMode}>
                <Layout className="layout">
                    <Header
                        style={{
                            position: 'fixed',
                            width: '100%',
                            top: 0,
                            [!rtl ? 'left' : 'right']: 0,
                        }}
                    >
                        <Row className="admin-header-row" wrap={false}>
                            <Col lg={4} md={12} sm={8} xs={10} className="align-center-v navbar-brand">
                                <Button type="link" onClick={toggleCollapsed}>
                                    <img
                                        src={require(`../static/img/icon/${
                                            setSidebarCollapsed ? 'right.svg' : 'left.svg'
                                        }`)}
                                        alt="menu"
                                    />
                                </Button>
                                <Link
                                    className={
                                        topMenu && window.innerWidth > 991 ? 'striking-logo top-menu' : 'striking-logo'
                                    }
                                    to="/admin"
                                >
                                    <img
                                        src="/icons/logo-with-text.svg"
                                        alt="logo"
                                        style={
                                            {
                                                //width: '1.5rem',
                                                // height: '3rem',
                                            }
                                        }
                                    />
                                    {/* <span style={{ color: 'black', fontSize: '1rem', marginLeft: '0.4rem' }}>
                                            Dashboard
                                        </span> */}
                                </Link>
                            </Col>
                            <Col lg={20} md={12} sm={16} xs={14} className="header-auth-actions">
                                <AuthInfo />
                            </Col>
                            {/* 
                                <Col md={0} sm={18} xs={12}>
                                    <div className="mobile-action">
                                        <Link className="btn-search" onClick={handleSearchHide} to="#">
                                            {searchHide ? <FeatherIcon icon="search" /> : <FeatherIcon icon="x" />}
                                        </Link>
                                        <Link className="btn-auth" onClick={onShowHide} to="#">
                                            <FeatherIcon icon="more-vertical" />
                                        </Link>
                                    </div>
                                </Col> */}
                        </Row>
                    </Header>
                    <Layout>
                        <Sider
                            width={280}
                            style={SideBarStyle}
                            collapsed={sidebarCollapsed}
                            theme={!darkMode ? 'light' : 'dark'}
                        >
                            <Scrollbars
                                className="custom-scrollbar"
                                autoHide
                                autoHideTimeout={500}
                                autoHideDuration={200}
                                renderThumbHorizontal={renderThumbHorizontal}
                                renderThumbVertical={renderThumbVertical}
                                renderView={renderView}
                                renderTrackVertical={renderTrackVertical}
                            >
                                <p className="sidebar-nav-title">OVERVIEW</p>
                                <MenuItems
                                    topMenu={topMenu}
                                    rtl={rtl}
                                    collapsed={sidebarCollapsed}
                                    toggleCollapsed={(collapsed) => {
                                        setSidebarCollapsed(collapsed);
                                    }}
                                    darkMode={darkMode}
                                />
                            </Scrollbars>
                        </Sider>
                        <Layout className="atbd-main-layout" style={{ height: '100%' }}>
                            <Content style={{ height: 'calc(100vh - 65px)' }}>
                                <CallOutcomePopup />
                                <WrappedComponent {...props} />
                            </Content>
                            {/* <Footer className="admin-footer" style={footerStyle}>
                                        <Row>
                                            <Col md={12} xs={24}>
                                                <span className="admin-footer__copyright">2023 © CommKraft</span>
                                            </Col>
                                            <Col md={12} xs={24}>
                                                <div className="admin-footer__links">
                                                    <NavLink to="#">Report a bug</NavLink>
                                                    <NavLink to="#">About</NavLink>
                                                    <NavLink to="#">Team</NavLink>
                                                    <NavLink to="#">Contact</NavLink>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Footer> */}
                        </Layout>
                    </Layout>
                </Layout>
            </Div>
        );
    };

    LayoutComponent.propTypes = {
        ChangeLayoutMode: propTypes.bool,
        rtl: propTypes.bool,
        topMenu: propTypes.bool,
        changeRtl: propTypes.func,
        changeLayout: propTypes.func,
        changeMenuMode: propTypes.func,
    };

    // return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
    return LayoutComponent;
};

export default ThemeLayout;
